/**
 * The uid Firestore will attach to a write sent right now, or `null` when signed out.
 *
 * WHY: firestore.rules (F-113) refuses a non-staff update to a project doc unless the doc AFTER the
 * write has `lastUpdatedBy` equal to the sender's `request.auth.uid` (null for a guest). An omitted
 * key keeps the previous writer's stamp and is refused. Read the SDK, not `$root.currentUser`: main.js
 * sets that only after awaiting `getIdTokenResult()`, so a guest who signs up mid-checkout would
 * stamp `null` while the write already carries their new uid.
 */
import { auth } from '@/firebaseConfig'

export function currentWriterUid () {
  return (auth && auth.currentUser && auth.currentUser.uid) || null
}
